import React, { useEffect, useState } from "react";
import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function VisitsSummary({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);
    const currentLeadData = [
        {
            amount: summaryData?.visitScheduled,
            label: "Total Visits",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'VS',
        },
        {
            amount: summaryData?.todaysVisitScheduled,
            label: "Today's Visits",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'TVS',
        },
        {
            amount: summaryData?.upcommingVisitScheduled,
            label: "Upcoming Visits",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'UVS',
        },
        // {
        //     amount: summaryData?.visitScheduled,
        //     label: "Completed Visits",
        //     color: "text-black",
        //     icon: <FaUser className="text-black" />,
        //     filter: 'VS',
        // },
    ];

    return (
        <Wrapper>

            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {currentLeadData.map((item, index) => (
                    <Card $selected={selectedId === index} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <ValueRow>
                            <Value color={item.color}>{item.amount}</Value>

                        </ValueRow>
                        <Label>
                            {item.label}
                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                    // <Card key={index} onClick={() => onClick(item.filter)}>
                    //     <div >
                    //         <span className={`text-lg font-bold ${item.color}`}>
                    //             {item.amount}
                    //         </span>
                    //         <Label>

                    //             {item.label}

                    //             {item.icon}
                    //         </Label>
                    //     </div>
                    // </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;

const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default VisitsSummary;

